import styled from 'styled-components';
import type { ValidatedRef } from '@entities/legal/types';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

const Pill = styled.span<{ $found: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: ${({ theme }) => theme.radius.pill};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.01em;
  background: ${({ $found, theme }) =>
    $found ? theme.colors.status.success + '1a' : theme.colors.status.warning + '1a'};
  color: ${({ $found, theme }) =>
    $found ? theme.colors.status.success : theme.colors.status.warning};
  border: 1px solid
    ${({ $found, theme }) =>
      $found ? theme.colors.status.success + '55' : theme.colors.status.warning + '55'};
  cursor: default;
`;

interface Props {
  refs: ValidatedRef[] | null | undefined;
}

/**
 * отображение валидации ссылок на НПА в риске.
 * Зелёный бэйдж «✓ ст. 756 ГК РФ» — норма найдена в загруженной KB.
 * Жёлтый бэйдж «⚠ ст. 426.1 ГК РФ» — норма не подтверждена (либо не
 * загружена в KB, либо LLM выдумала).
 */
export function RiskRefs({ refs }: Props) {
  if (!refs || refs.length === 0) return null;

  return (
    <Row>
      {refs.map((r, idx) => (
        <Pill
          key={`${r.citation}-${idx}`}
          $found={r.found}
          title={
            r.found
              ? `Подтверждено: ${r.source_title ?? ''} (score ${r.score.toFixed(2)})`
              : 'Ссылка не подтверждена в базе знаний. Возможно, норма не загружена или цитата неточная.'
          }
        >
          {r.found ? '✓' : '⚠'} {r.citation}
        </Pill>
      ))}
    </Row>
  );
}
